import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { flattenMessages } from '../../utils';

function PolicyModal(props) {
  const [isChecked, setIsChecked] = useState(false);
  const messages = props.policy_messages;

  if (props.selectedzone === null) {
    return null;
  }

  const data = messages[`spacetype_${props.selectedzone.spacetype}`];
  return (
    <Modal size='xl'
      id='policyModal'
      show={props.show}
      onHide={() => {
        props.setSelectedZone(null);
        props.setPolicyShow(false);
      }}
      dialogClassName="modal-95w"
      centered
    >
      <Modal.Header className="bg_brand" closeButton>
        <Modal.Title>
          <span><FormattedMessage defaultMessage={props.selectedzone.zonename} id={`global.spacetype.${props.selectedzone.spacetype}`} /> <FormattedMessage id='appointment.policy' /></span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {data !== undefined ?
          <IntlProvider locale={props.locale} key={props.locale} messages={flattenMessages(messages)}>
            <ol>
              {
                Object.keys(data).map((item, i) => {
                  return (
                    <CustomTag key={i} langObj={`spacetype_${props.selectedzone.spacetype}.${item}`} jsondata={data[item]} />
                  )
                })
              }
            </ol>
          </IntlProvider>
          : '查無對應空間類型的語系資料'}
      </Modal.Body>
      <Modal.Footer className='d-flex justify-content-between'>
        <div className="d-flex align-items-center">
          <input type="checkbox" id="confirm_policy" onChange={(e) => { setIsChecked(!isChecked); }} />
          <label className="mb-0 confirm_policy_label" htmlFor="confirm_policy"><FormattedMessage id='appointment.confirm_policy' /></label>
        </div>
        <Button className="bg_brand" variant="primary" disabled={!isChecked} onClick={() => {
          props.setPolicyShow(false);
          props.setshow(true);
        }}><FormattedMessage id='global.next' /></Button>
      </Modal.Footer>
    </Modal>
  )
}

const CustomTag = (props) => {
  const TagName = (tagprops) => {
    let InnerTagName = props.jsondata.tag;
    let tagClass = props.jsondata.class || null;
    let tagHref = props.jsondata.href || null;
    let hrefTarget = props.jsondata.href ? '_blank' : null;
    let rowspan = props.jsondata.rowspan || null;
    if (InnerTagName) {
      return <InnerTagName className={tagClass} href={tagHref} target={hrefTarget} rowSpan={rowspan}>{tagprops.children}</InnerTagName>
    } else {
      return <>{tagprops.children}</>
    }
  };
  if (props.jsondata.children) {
    return (
      <TagName>
        {props.jsondata.content ? <FormattedMessage id={`${props.langObj}.content`} /> : null}
        {
          Object.keys(props.jsondata.children).map((item, i) => {
            return (
              <CustomTag key={i} langObj={`${props.langObj}.children.${item}`} jsondata={props.jsondata.children[item]} />
            )
          })
        }
      </TagName>
    )
  } else {
    return (
      <TagName>
        <FormattedMessage id={`${props.langObj}.content`} />
      </TagName>
    )
  }
}

export default PolicyModal;